import { Space } from 'antd';
import { PropsWithChildren, ReactNode } from 'react';

import { GoBack } from '@entities';

import * as S from './styled';

type DetailsHeaderProps = {
  /** Label for the back link (defaults to "Go Back" via {@link GoBack}). */
  goBackText?: ReactNode;
  /** Invoked when the back link is clicked; falls back to `navigate(-1)`. */
  onNavigate?: VoidFunction;
  /**
   * Optional content rendered at the far right of the header, opposite the
   * back link. Intended for page-level actions such as prev/next navigation.
   * Omit to keep the header left-aligned only.
   */
  extra?: ReactNode;
};

const DetailsHeader = ({
  children,
  goBackText,
  onNavigate,
  extra,
}: PropsWithChildren<DetailsHeaderProps>) => (
  <S.Header>
    <S.Content>
      <Space split={<S.Divider />}>
        <GoBack text={goBackText} onNavigate={onNavigate} />
        {children}
      </Space>
      {extra}
    </S.Content>
  </S.Header>
);

export default DetailsHeader;
